import script from "./multipleChoice.vue?vue&type=script&setup=true&lang=js"
export * from "./multipleChoice.vue?vue&type=script&setup=true&lang=js"

import "./multipleChoice.vue?vue&type=style&index=0&id=0236797f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0236797f"]])

export default __exports__